// Product analytics (docs/analytics.md section 7): session replay masks all text, and autocapture keeps no label, link
// or name of what is clicked inside elements with the mask attribute; elements with the hide attribute (chats and
// direct messages) are recorded as an empty box, attributes included (lib/analytics re-exports these).
import { createContext, useContext } from 'react'

export const MASK_ATTR = 'data-mp-mask'
export const HIDE_ATTR = 'data-mp-hide'
export const PRIVATE_ATTRS = { [MASK_ATTR]: 'true' } as const
export const HIDDEN_ATTRS = { [MASK_ATTR]: 'true', [HIDE_ATTR]: 'true' } as const

export type PrivateAttrs = Partial<Record<typeof MASK_ATTR | typeof HIDE_ATTR, 'true'>>

export const PrivateAreaContext = createContext<PrivateAttrs>({})

/** The private attributes for overlay content (dialogs, sheets, popovers, menus, tooltips) opened inside a private
 *  area: their portals render outside the private element, so they take them from the PrivateScope around whatever
 *  opened them. */
export function usePrivateAttrs(): PrivateAttrs {
  return useContext(PrivateAreaContext)
}
